import React from "react";
import "./HRCopilotProfessionals.css";

const HRCopilotProfessionals = () => {
  const team = [
    {
      role: "REQUIREMENT",
      name: "Smart Requirement",
      desc: "HR Copilot helps you collect, refine, and manage job requirements effortlessly.",
      img: "/images/profi1.png",
      circleColor: "#C62828",
    },
    {
      role: "HR ONBOARDNG",
      name: "Smart Onboarding",
      desc: "Gosh noiselessly inconspicuous a haggardly one foolish with dolphin heartless growled.",
      img: "/images/profi2.png",
      circleColor: "#303845",
    },
    {
      role: "HR SENIOR EXECUTIVE",
      name: "Smart Automation",
      desc: "Therefore excitedly crab one despite crud one far spluttered less less up dwelled.",
      img: "/images/profi3.png",
      circleColor: "#C62828",
    },
    {
      role: "HR PROFESSIONAL",
      name: "Smart Management",
      desc: "Assisted one wasp in amid began yikes until some opaque hen wishfully thus and constantly.",
      img: "/images/profi4.png",
      circleColor: "#303845",
    },
  ];

  return (
    <section className="hrtpro-section">

      {/* HEADING */}
      <div className="hrtpro-heading">
        {/* <p className="hrtpro-subtitle">WE ARE THERE FOR YOU</p> */}
        <h2 className="hrtpro-title">
          Humanex <span>Extremly Features</span>
        </h2>
      </div>

      {/* TEAM GRID */}
      <div className="hrtpro-grid">

        {team.map((item, index) => (
          <div key={index} className="hrtpro-card">

            {/* IMAGE SHAPE */}
            <div className="hrtpro-image-wrapper">
              <img src={item.img} alt={item.name} className="hrtpro-image" />
              <div
                className="hrtpro-circle"
                style={{ background: item.circleColor }}
              ></div>
            </div>

            {/* TEXT */}
            <p className="hrtpro-role">{item.role}</p>
            <h3 className="hrtpro-name">{item.name}</h3>
            <p className="hrtpro-desc">{item.desc}</p>

            <a href="/access-recruit" className="hrtpro-link">
              FIND OUT MORE →
            </a>
          </div>
        ))}

      </div>
    </section>
  );
};

export default HRCopilotProfessionals;
